export class LabelValue {
  label?: string;
  value?: any;
}
export class Cities {
  country?: string;
  cities?: string[];
}

export const CITIES: Cities[] = [
  { country: 'Holland', cities: ['Amsterdam', 'Rotterdam', 'Utrecht', 'Lahey', 'Delft', 'Eindhoven', 'Groningen', 'Haarlem'] },
  {
    country: 'Turkey',
    cities: [
      'Adana',
      'Adiyaman',
      'Afyon',
      'Agri',
      'Aksaray',
      'Amasya',
      'Ankara',
      'Antalya',
      'Ardahan',
      'Artvin',
      'Aydin',
      'Balikesir',
      'Bartin',
      'Batman',
      'Bayburt',
      'Bilecik',
      'Bingol',
      'Bitlis',
      'Bolu',
      'Burdur',
      'Bursa',
      'Canakkale',
      'Cankiri',
      'Corum',
      'Denizli',
      'Diyarbakir',
      'Duzce',
      'Edirne',
      'Elazig',
      'Erzincan',
      'Erzurum',
      'Eskisehir',
      'Gaziantep',
      'Giresun',
      'Gumushane',
      'Hakkari',
      'Hatay',
      'Igdir',
      'Isparta',
      'Istanbul',
      'Izmir',
      'Kahramanmaras',
      'Karabuk',
      'Karaman',
      'Kars',
      'Kastamonu',
      'Kayseri',
      'Kilis',
      'Kirikkale',
      'Kirklareli',
      'Kirsehir',
      'Kocaeli',
      'Konya',
      'Kutahya',
      'Malatya',
      'Manisa',
      'Mardin',
      'Mersin',
      'Mugla',
      'Mus',
      'Nevsehir',
      'Nigde',
      'Ordu',
      'Osmaniye',
      'Rize',
      'Sakarya',
      'Samsun',
      'Sanliurfa',
      'Siirt',
      'Sinop',
      'Sirnak',
      'Sivas',
      'Tekirdag',
      'Tokat',
      'Trabzon',
      'Tunceli',
      'Usak',
      'Van',
      'Yalova',
      'Yozgat',
      'Zonguldak',
    ],
  },
];

export const DEVICE: LabelValue[] = [
  { label: 'IOS MOBILE', value: 'MobileIos' },
  { label: 'ANDROID MOBILE', value: 'MobileAndroid' },
  { label: 'WEB', value: 'Web' },
  // {label: 'TV', value: 'Tv'},
  // {label: 'SMART TV', value: 'SmartTv'},
  // {label: 'WEB CHROME', value: 'WebChrome'},
  // {label: 'WEB SAFARI', value: 'WebSafari'},
  // {label: 'WEB EDGE', value: 'WebEdge'},
  { label: 'Apple TV', value: 'AppleTv' },
  { label: 'Android TV', value: 'AndroidTv' },
];
export const PackageType: LabelValue[] = [
  { label: 'DASH', value: 'DASH' },
  { label: 'HLS', value: 'HLS' },
];

export const QuickFilters: any[] = [
  { label: 'Trailer Waiting Contents', value: 'trailer_waiting' },
  { label: 'Video File Operation Finished Today', value: 'vfsqc3_finish_today' },
  { label: 'License Started Today Contents', value: 'lic_start_today' },
  { label: 'Jobs in Operation Contents', value: 'vfo_active' },
  { label: 'monthly completed jobs', value: 'vfo_finished_last_30' },
  { label: 'Annually Completed Jobs ', value: 'vfo_finished_last_365' },
  { label: 'License started but not published contents', value: 'lic_start_not_pub' },
  { label: 'Last 15 days to license start contents', value: '15days_to_lic_start' },
  { label: 'Censorship Waiting Contents', value: 'censorship_waiting' },
];

export const Countries: any[] = [
  { label: 'Afghanistan', value: 'Afghanistan' },
  { label: 'Albania', value: 'Albania' },
  { label: 'Algeria', value: 'Algeria' },
  { label: 'Andorra', value: 'Andorra' },
  { label: 'Angola', value: 'Angola' },
  { label: 'Antigua and Barbuda', value: 'Antigua and Barbuda' },
  { label: 'Argentina', value: 'Argentina' },
  { label: 'Armenia', value: 'Armenia' },
  { label: 'Australia', value: 'Australia' },
  { label: 'Austria', value: 'Austria' },
  { label: 'Azerbaijan', value: 'Azerbaijan' },
  { label: 'Bahamas', value: 'Bahamas' },
  { label: 'Bahrain', value: 'Bahrain' },
  { label: 'Bangladesh', value: 'Bangladesh' },
  { label: 'Barbados', value: 'Barbados' },
  { label: 'Belarus', value: 'Belarus' },
  { label: 'Belgium', value: 'Belgium' },
  { label: 'Belize', value: 'Belize' },
  { label: 'Benin', value: 'Benin' },
  { label: 'Bhutan', value: 'Bhutan' },
  { label: 'Bolivia', value: 'Bolivia' },
  { label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
  { label: 'Botswana', value: 'Botswana' },
  { label: 'Brazil', value: 'Brazil' },
  { label: 'Brunei', value: 'Brunei' },
  { label: 'Bulgaria', value: 'Bulgaria' },
  { label: 'Burkina Faso', value: 'Burkina Faso' },
  { label: 'Burundi', value: 'Burundi' },
  { label: 'Cote dIvoire', value: 'Cote dIvoire' },
  { label: 'Cabo Verde', value: 'Cabo Verde' },
  { label: 'Cambodia', value: 'Cambodia' },
  { label: 'Cameroon', value: 'Cameroon' },
  { label: 'Canada', value: 'Canada' },
  { label: 'Central African Republic', value: 'Central African Republic' },
  { label: 'Chad', value: 'Chad' },
  { label: 'Chile', value: 'Chile' },
  { label: 'China', value: 'China' },
  { label: 'Colombia', value: 'Colombia' },
  { label: 'Comoros', value: 'Comoros' },
  { label: 'Congo', value: 'Congo' },
  { label: 'Costa Rica', value: 'Costa Rica' },
  { label: 'Croatia', value: 'Croatia' },
  { label: 'Cuba', value: 'Cuba' },
  { label: 'Cyprus', value: 'Cyprus' },
  { label: 'Czechia', value: 'Czechia' },
  { label: 'Democratic Republic of the Congo', value: 'Democratic Republic of the Congo' },
  { label: 'Denmark', value: 'Denmark' },
  { label: 'Djibouti', value: 'Djibouti' },
  { label: 'Dominica', value: 'Dominica' },
  { label: 'Dominican Republic', value: 'Dominican Republic' },
  { label: 'Ecuador', value: 'Ecuador' },
  { label: 'Egypt', value: 'Egypt' },
  { label: 'El Salvador', value: 'El Salvador' },
  { label: 'Equatorial Guinea', value: 'Equatorial Guinea' },
  { label: 'Eritrea', value: 'Eritrea' },
  { label: 'Estonia', value: 'Estonia' },
  { label: 'Eswatini', value: 'Eswatini' },
  { label: 'Ethiopia', value: 'Ethiopia' },
  { label: 'Fiji', value: 'Fiji' },
  { label: 'Finland', value: 'Finland' },
  { label: 'France', value: 'France' },
  { label: 'Gabon', value: 'Gabon' },
  { label: 'Gambia', value: 'Gambia' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Germany', value: 'Germany' },
  { label: 'Ghana', value: 'Ghana' },
  { label: 'Greece', value: 'Greece' },
  { label: 'Grenada', value: 'Grenada' },
  { label: 'Guatemala', value: 'Guatemala' },
  { label: 'Guinea', value: 'Guinea' },
  { label: 'Guinea-Bissau', value: 'Guinea-Bissau' },
  { label: 'Guyana', value: 'Guyana' },
  { label: 'Haiti', value: 'Haiti' },
  { label: 'Holy See', value: 'Holy See' },
  { label: 'Honduras', value: 'Honduras' },
  { label: 'Hungary', value: 'Hungary' },
  { label: 'Iceland', value: 'Iceland' },
  { label: 'India', value: 'India' },
  { label: 'Indonesia', value: 'Indonesia' },
  { label: 'Iran', value: 'Iran' },
  { label: 'Iraq', value: 'Iraq' },
  { label: 'Ireland', value: 'Ireland' },
  { label: 'Israel', value: 'Israel' },
  { label: 'Italy', value: 'Italy' },
  { label: 'Jamaica', value: 'Jamaica' },
  { label: 'Japan', value: 'Japan' },
  { label: 'Jordan', value: 'Jordan' },
  { label: 'Kazakhstan', value: 'Kazakhstan' },
  { label: 'Kenya', value: 'Kenya' },
  { label: 'Kiribati', value: 'Kiribati' },
  { label: 'Kuwait', value: 'Kuwait' },
  { label: 'Kyrgyzstan', value: 'Kyrgyzstan' },
  { label: 'Laos', value: 'Laos' },
  { label: 'Latvia', value: 'Latvia' },
  { label: 'Lebanon', value: 'Lebanon' },
  { label: 'Lesotho', value: 'Lesotho' },
  { label: 'Liberia', value: 'Liberia' },
  { label: 'Libya', value: 'Libya' },
  { label: 'Liechtenstein', value: 'Liechtenstein' },
  { label: 'Lithuania', value: 'Lithuania' },
  { label: 'Luxembourg', value: 'Luxembourg' },
  { label: 'Madagascar', value: 'Madagascar' },
  { label: 'Malawi', value: 'Malawi' },
  { label: 'Malaysia', value: 'Malaysia' },
  { label: 'Maldives', value: 'Maldives' },
  { label: 'Mali', value: 'Mali' },
  { label: 'Malta', value: 'Malta' },
  { label: 'Marshall Islands', value: 'Marshall Islands' },
  { label: 'Mauritania', value: 'Mauritania' },
  { label: 'Mauritius', value: 'Mauritius' },
  { label: 'Mexico', value: 'Mexico' },
  { label: 'Micronesia', value: 'Micronesia' },
  { label: 'Moldova', value: 'Moldova' },
  { label: 'Monaco', value: 'Monaco' },
  { label: 'Mongolia', value: 'Mongolia' },
  { label: 'Montenegro', value: 'Montenegro' },
  { label: 'Morocco', value: 'Morocco' },
  { label: 'Mozambique', value: 'Mozambique' },
  { label: 'Myanmar', value: 'Myanmar' },
  { label: 'Namibia', value: 'Namibia' },
  { label: 'Nauru', value: 'Nauru' },
  { label: 'Nepal', value: 'Nepal' },
  { label: 'Netherlands', value: 'Netherlands' },
  { label: 'New Zealand', value: 'New Zealand' },
  { label: 'Nicaragua', value: 'Nicaragua' },
  { label: 'Niger', value: 'Niger' },
  { label: 'Nigeria', value: 'Nigeria' },
  { label: 'North Korea', value: 'North Korea' },
  { label: 'North Macedonia', value: 'North Macedonia' },
  { label: 'Norway', value: 'Norway' },
  { label: 'Oman', value: 'Oman' },
  { label: 'Pakistan', value: 'Pakistan' },
  { label: 'Palau', value: 'Palau' },
  { label: 'Palestine State', value: 'Palestine State' },
  { label: 'Panama', value: 'Panama' },
  { label: 'Papua New Guinea', value: 'Papua New Guinea' },
  { label: 'Paraguay', value: 'Paraguay' },
  { label: 'Peru', value: 'Peru' },
  { label: 'Philippines', value: 'Philippines' },
  { label: 'Poland', value: 'Poland' },
  { label: 'Portugal', value: 'Portugal' },
  { label: 'Qatar', value: 'Qatar' },
  { label: 'Romania', value: 'Romania' },
  { label: 'Russia', value: 'Russia' },
  { label: 'Rwanda', value: 'Rwanda' },
  { label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis' },
  { label: 'Saint Lucia', value: 'Saint Lucia' },
  { label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines' },
  { label: 'Samoa', value: 'Samoa' },
  { label: 'San Marino', value: 'San Marino' },
  { label: 'Sao Tome and Principe', value: 'Sao Tome and Principe' },
  { label: 'Saudi Arabia', value: 'Saudi Arabia' },
  { label: 'Senegal', value: 'Senegal' },
  { label: 'Serbia', value: 'Serbia' },
  { label: 'Seychelles', value: 'Seychelles' },
  { label: 'Sierra Leone', value: 'Sierra Leone' },
  { label: 'Singapore', value: 'Singapore' },
  { label: 'Slovakia', value: 'Slovakia' },
  { label: 'Slovenia', value: 'Slovenia' },
  { label: 'Solomon Islands', value: 'Solomon Islands' },
  { label: 'Somalia', value: 'Somalia' },
  { label: 'South Africa', value: 'South Africa' },
  { label: 'South Korea', value: 'South Korea' },
  { label: 'South Sudan', value: 'South Sudan' },
  { label: 'Spain', value: 'Spain' },
  { label: 'Sri Lanka', value: 'Sri Lanka' },
  { label: 'Sudan', value: 'Sudan' },
  { label: 'Suriname', value: 'Suriname' },
  { label: 'Sweden', value: 'Sweden' },
  { label: 'Switzerland', value: 'Switzerland' },
  { label: 'Syria', value: 'Syria' },
  { label: 'Tajikistan', value: 'Tajikistan' },
  { label: 'Tanzania', value: 'Tanzania' },
  { label: 'Thailand', value: 'Thailand' },
  { label: 'Timor-Leste', value: 'Timor-Leste' },
  { label: 'Togo', value: 'Togo' },
  { label: 'Tonga', value: 'Tonga' },
  { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
  { label: 'Tunisia', value: 'Tunisia' },
  { label: 'Turkey', value: 'Turkey' },
  { label: 'Turkmenistan', value: 'Turkmenistan' },
  { label: 'Tuvalu', value: 'Tuvalu' },
  { label: 'Uganda', value: 'Uganda' },
  { label: 'Ukraine', value: 'Ukraine' },
  { label: 'United Arab Emirates', value: 'United Arab Emirates' },
  { label: 'United Kingdom', value: 'United Kingdom' },
  { label: 'England', value: 'England' },
  { label: 'USA', value: 'USA' },
  { label: 'Uruguay', value: 'Uruguay' },
  { label: 'Uzbekistan', value: 'Uzbekistan' },
  { label: 'Vanuatu', value: 'Vanuatu' },
  { label: 'Venezuela', value: 'Venezuela' },
  { label: 'Vietnam', value: 'Vietnam' },
  { label: 'Yemen', value: 'Yemen' },
  { label: 'Zambia', value: 'Zambia' },
  { label: 'Zimbabwe', value: 'Zimbabwe' },
];
export const Languages = [
  'Turkish',
  'English'
];
export const ContentStatuses: LabelValue[] = [
  { label: 'WaitingForMaterials', value: 'WaitingForMaterials' },
  { label: 'RawContent', value: 'RawContent' },
  { label: 'InProgress', value: 'InProgress' },
  { label: 'ReadyForPublish', value: 'ReadyForPublish' },
  { label: 'Published', value: 'Published' },
  { label: 'NoActiveLicense', value: 'NoActiveLicense' },
  { label: 'Deleted', value: 'Deleted' },
  { label: 'Expired', value: 'Expired' },
  { label: 'None', value: 'None' },
];

export const MediaFileFormats: LabelValue[] = [
  { label: 'Mezzanie File', value: 'RawVideo' },
  { label: 'M&E', value: 'ME' },
  { label: 'Audio File', value: 'Audio' },
  { label: 'ScriptFile', value: 'Script' },
];

export const ChannelTypes: LabelValue[] = [
  { label: 'All', value: 'ALL' },
  { label: 'RTMP', value: 'RTMP' },
  { label: 'Public URL', value: 'PublicURL' },
];

export const VideoFormats: LabelValue[] = [
  { label: '6k', value: 'SixK' },
  { label: '4K', value: 'FourK' },
  { label: 'HD', value: 'HD' },
  { label: 'SD', value: 'SD' },
];

export const VodTypes: LabelValue[] = [
  { label: 'None', value: '' },
  { label: 'Vod', value: 'Vod' },
  { label: 'Cutv', value: 'Cutv' },
];

export const ThirdPartyOperations: LabelValue[] = [
  { label: 'Film Dubbing', value: 'FilmDubbing' },
  { label: 'Series Dubbing', value: 'SeriesDubbing' },
  { label: 'Cartoon Series Dubbing', value: 'CartoonSeriesDubbing' },
  { label: 'Documentary Sycronized Dubbing', value: 'DocumentarySynchronizedDubbing' },
  { label: 'Voice Over Dubbing', value: 'VoiceOverDubbing' },
  { label: "Film Subtitle 120'", value: 'FilmSubtitle120' },
  { label: "Film Subtitle over 120'", value: 'FilmSubtitleOver120' },
  { label: "Series Documentary Subtitle 3'", value: 'SeriesDocumentarySubtitle3' },
  { label: "Series Documentary Subtitle 5'", value: 'SeriesDocumentarySubtitle5' },
  { label: "Series Documentary Subtitle 15'", value: 'SeriesDocumentarySubtitle15' },
  { label: "Series Documentary Subtitle 30'", value: 'SeriesDocumentarySubtitle30' },
  { label: "Series Documentary Subtitle 45'", value: 'SeriesDocumentarySubtitle45' },
  { label: "Series Documentary Subtitle 60'", value: 'SeriesDocumentarySubtitle60' },
  { label: "Series Documentary Subtitle 90'", value: 'SeriesDocumentarySubtitle90' },
  { label: "Series Documentary Subtitle 120'", value: 'SeriesDocumentarySubtitle120' },
  { label: "Film Subtitle in English 120' & over 120'", value: 'FilmSubtitleInEnglish120_Over120' },
  { label: "Series Subtitle in English 60'", value: 'SeriesSubtitleInEnglish60' },
  { label: "Enter 15'", value: 'Enter15' },
  { label: "Enter 30'", value: 'Enter30' },
  { label: "Enter 45'", value: 'Enter45' },
  { label: "Enter 60'", value: 'Enter60' },
  { label: "Enter 90'", value: 'Enter90' },
  { label: 'Film Enter (Full M&E File)', value: 'FilmEnter_Full_M_E_File' },
  { label: "Subtitle Editing 0-30'", value: 'SubtitleEditing0_30' },
  { label: "Subtitle Editing 30-60'", value: 'SubtitleEditing30_60' },
  { label: "Subtitle Editing 60-120'", value: 'SubtitleEditing60_120' },
  { label: "Subtitle Editing over 120'", value: 'SubtitleEditingOver_120' },
  { label: 'None', value: 'None' },
];
export const VideoOperationStatuses: string[] = ['Pending', 'Started', 'Finished', 'Passed', 'Failed'];
// <option value="vfo_finish_today">VFO işlemleri bugün tamamlananlar</option>
// <option value="lic_start_today">Lisansı Başlamış İçerikler</option>
// <option value="vfo_active">Operasyondaki İşler</option>
// <option value="vfo_finished_last_30">Aylık Biten İşler</option>
// <option value="vfo_finished_last_365">Yıllık Biten İşler</option>
export const TrailerOperationPriority: string[] = ['High', 'Medium', 'Low'];

export const TrailerPromo: LabelValue[] = [
  { label: 'Generic Promo', value: 'GenericPromo' },
  { label: 'Mountly Promo', value: 'MountlyPromo' },
  { label: 'Single Promo', value: 'SinglePromo' },
  { label: 'Special Days Promo', value: 'SpecialDaysPromo' },
];
export const TrailerPromos: string[] = ['GenericPromo', 'MountlyPromo', 'SinglePromo', 'SpecialDaysPromo'];

export const VfoProcessStatues: string[] = ['Pending', 'Started', 'Finished', 'Passed', 'Updated', 'Failed'];

export const LicenseSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Service Type - Ascending', value: 'serviceType-asc' },
  { label: 'Service Type - Descending', value: 'serviceType-desc' },
  { label: 'Start Time - Ascending', value: 'startTime-asc' },
  { label: 'Start Time - Descending', value: 'startTime-desc' },
  { label: 'End Time - Ascending', value: 'endTime-asc' },
  { label: 'End Time - Descending', value: 'endTime-desc' },
  { label: 'Status - Ascending', value: 'status-asc' },
  { label: 'Status - Descending', value: 'status-desc' },
  { label: 'Currency - Ascending', value: 'currency-asc' },
  { label: 'Currency - Descending', value: 'currency-desc' },
];
export const SpecialContentsSortOptions: LabelValue[] = [
  { label: 'Process Name - Ascending', value: 'processNames-asc' },
  { label: 'Process Name - Descending', value: 'processNames-desc' },
];

export const ProviderSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Country - Ascending', value: 'country-asc' },
  { label: 'Country - Descending', value: 'country-desc' },
  { label: 'Notes - Ascending', value: 'notes-asc' },
  { label: 'Notes - Descending', value: 'notes-desc' },
];
export const ContractSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Provider - Ascending', value: 'provider-asc' },
  { label: 'Provider - Descending', value: 'provider-desc' },
  { label: 'Start Time - Ascending', value: 'startTime-asc' },
  { label: 'Start Time - Descending', value: 'startTime-desc' },
  { label: 'End Time - Ascending', value: 'endTime-asc' },
  { label: 'End Time - Descending', value: 'endTime-desc' },
];

export const ContentSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Provider - Ascending', value: 'provider-asc' },
  { label: 'Provider - Descending', value: 'provider-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseMinStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseMinStartTime-desc' },
  { label: 'License End Time - Ascending', value: 'licenseMaxEndTime-asc' },
  { label: 'License End Time - Descending', value: 'licenseMaxEndTime-desc' },
  { label: 'Plan Start Time - Ascending', value: 'planMinStartTime-asc' },
  { label: 'Plan Start Time - Descending', value: 'planMinStartTime-desc' },
  { label: 'Plan End Time - Ascending', value: 'planMaxEndTime-asc' },
  { label: 'Plan End Time - Descending', value: 'planMaxEndTime-desc' },
  { label: 'Original Title - Ascending', value: 'originalTitle-asc' },
  { label: 'Original Title - Descending', value: 'originalTitle-desc' },
  { label: 'Broadcast Time - Ascending', value: 'boradCastTime-asc' },
  { label: 'Broadcast Time - Descending', value: 'boradCastTime-desc' },
  { label: 'Trailer Operation Priority - Ascending', value: 'trailerOperationPriority-asc' },
  { label: 'Trailer Operation Priority - Descending', value: 'trailerOperationPriority-desc' },
  { label: 'Trailer Operation Name - Ascending', value: 'trailerOperationProcessName-asc' },
  { label: 'Trailer Operation Name - Descending', value: 'trailerOperationProcessName-desc' },
  { label: 'Video Operation Process  Name - Ascending', value: 'vfoProcessName-asc' },
  { label: 'Video Operation Process  Name - Descending', value: 'vfoProcessName-desc' },
  { label: 'CensorshipPreview Time - Ascending', value: 'censorshipPreviewEditTime-asc' },
  { label: 'CensorshipPreview  Time - Descending', value: 'censorshipPreviewEditTime-desc' },
  { label: 'CensorshipPreview Status - Ascending', value: 'censorshipStatus-asc' },
  { label: 'CensorshipPreview  Status - Descending', value: 'censorshipStatus-desc' },
  { label: 'License Service Type - Ascending', value: 'licenseServiceType-asc' },
  { label: 'License Service Type - Descending', value: 'licenseServiceType-desc' },
  { label: 'Genre - Ascending', value: 'genreName-asc' },
  { label: 'Genre - Descending', value: 'genreName-desc' },
  { label: 'Year - Ascending', value: 'year-asc' },
  { label: 'Year - Descending', value: 'year-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Service Type - Ascending', value: 'serviceType-asc' },
  { label: 'Service Type - Descending', value: 'serviceType-desc' },
];

export const CpiDashboardSortOptions = {
  title: { asc: 'title-asc', desc: 'title-desc' },
  type: { asc: 'type-asc', desc: 'type-desc' },
  startTime: { asc: 'startTime-asc', desc: 'startTime-desc' },
  endTime: { asc: 'endTime-asc', desc: 'endTime-desc' },
  provider: { asc: 'provider-asc', desc: 'provider-desc' },
  contentCount: { asc: 'contentCount-asc', desc: 'contentCount-desc' },
  status: { asc: 'status-asc', desc: 'status-desc' },
  videoStatus: { asc: 'videoStatus-asc', desc: 'videoStatus-desc' },
  createdAt: { asc: 'createdAt-asc', desc: 'createdAt-desc' },
};

export const PosterJobSortOptions: LabelValue[] = [
  { label: 'Content Name - Ascending', value: 'name-asc' },
  { label: 'Content Name - Descending', value: 'name-desc' },
  { label: 'Job  Start Time - Ascending', value: 'startDate-asc' },
  { label: 'Job  Start Time - Descending', value: 'startDate-desc' },
  { label: 'Job  End Time - Ascending', value: 'endDate-asc' },
  { label: 'Job  End Time - Descending', value: 'endDate-desc' },
];

export const PlanningListContentSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Status - Ascending', value: 'contentStatus-asc' },
  { label: 'Status - Descending', value: 'contentStatus-desc' },
  { label: 'Video Operation Process  Name - Ascending', value: 'vfoProcessName-asc' },
  { label: 'Video Operation Process  Name - Descending', value: 'vfoProcessName-desc' },
];
export const contentsWithoutPosterSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseMinStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseMinStartTime-desc' },
  { label: 'License End Time - Ascending', value: 'licenseMaxEndTime-asc' },
  { label: 'License End Time - Descending', value: 'licenseMaxEndTime-desc' },
  { label: 'License Service Type - Ascending', value: 'serviceType-asc' },
  { label: 'License Service Type - Descending', value: 'serviceType-desc' },
  { label: 'Genre - Ascending', value: 'genreName-asc' },
  { label: 'Genre - Descending', value: 'genreName-desc' },
  { label: 'Status - Ascending', value: 'contentStatus-asc' },
  { label: 'Status - Descending', value: 'contentStatus-desc' },
];
export const contentsWithoutPlatformSequenceIndependentOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseMinStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseMinStartTime-desc' },
  { label: 'License End Time - Ascending', value: 'licenseMaxEndTime-asc' },
  { label: 'License End Time - Descending', value: 'licenseMaxEndTime-desc' },
  { label: 'License Service Type - Ascending', value: 'serviceType-asc' },
  { label: 'License Service Type - Descending', value: 'serviceType-desc' },
  { label: 'Year - Ascending', value: 'year-asc' },
  { label: 'Year - Descending', value: 'year-desc' },
];

export const LtvChannelsSortOptions: LabelValue[] = [
  { label: 'Display Number - Ascending', value: 'displayNumber-asc' },
  { label: 'Display Number - Descending', value: 'displayNumber-desc' },
  { label: 'Channel Name - Ascending', value: 'name-asc' },
  { label: 'Channel Name - Descending', value: 'name-desc' },
  { label: 'Channel Status - Ascending', value: 'status-asc' },
  { label: 'Channel Status - Descending', value: 'status-desc' },
  { label: 'Genre - Ascending', value: 'genre-asc' },
  { label: 'Genre - Descending', value: 'genre-desc' },
  { label: 'Sequence - Ascending', value: 'priority-asc' },
  { label: 'Sequence - Descending', value: 'priority-desc' },
];

export const CatchupSortOptions: LabelValue[] = [
  { label: 'Channel Name - Ascending', value: 'channelName-asc' },
  { label: 'Channel Name - Descending', value: 'channelName-desc' },
  { label: 'Release Date - Ascending', value: 'releaseDate-asc' },
  { label: 'Release Date - Descending', value: 'releaseDate-desc' },
  { label: 'Program Name - Ascending', value: 'name-asc' },
  { label: 'Program Name - Descending', value: 'name-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Start Time - Ascending', value: 'startTime-asc' },
  { label: 'Start Time - Descending', value: 'startTime-desc' },
  { label: 'End Time - Ascending', value: 'endTime-asc' },
  { label: 'End Time - Descending', value: 'endTime-desc' },
  { label: 'Status - Ascending', value: 'status-asc' },
  { label: 'Status - Descending', value: 'status-desc' },
];
export const CatchupRequestSortOptions: LabelValue[] = [
  { label: 'Channel Name - Ascending', value: 'channelName-asc' },
  { label: 'Channel Name - Descending', value: 'channelName-desc' },
  { label: 'Release Date - Ascending', value: 'releaseDate-asc' },
  { label: 'Release Date - Descending', value: 'releaseDate-desc' },
  { label: 'Program Name - Ascending', value: 'programTitle-asc' },
  { label: 'Program Name - Descending', value: 'programTitle-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Start Hour - Ascending', value: 'programStartHour-asc' },
  { label: 'Start Hour - Descending', value: 'programStartHour-desc' },
  { label: 'End Hour - Ascending', value: 'programEndHour-asc' },
  { label: 'End Hour - Descending', value: 'programEndHour-desc' },
  { label: 'Status - Ascending', value: 'status-asc' },
  { label: 'Status - Descending', value: 'status-desc' },
];

export const EpgSortOptions: LabelValue[] = [
  { label: 'Channel Name - Ascending', value: 'channelName-asc' },
  { label: 'Channel Name - Descending', value: 'channelName-desc' },
  { label: 'Program Title - Ascending', value: 'title-asc' },
  { label: 'Program Title - Descending', value: 'title-desc' },
  { label: 'Release Date - Ascending', value: 'releaseDate-asc' },
  { label: 'Release Date - Descending', value: 'releaseDate-desc' },
  { label: 'Start Time - Ascending', value: 'startTime-asc' },
  { label: 'Start Time - Descending', value: 'startTime-desc' },
  { label: 'End Time - Ascending', value: 'endTime-asc' },
  { label: 'End Time - Descending', value: 'endTime-desc' },
  { label: 'Broadcast Type - Ascending', value: 'broadcastType-asc' },
  { label: 'Broadcast Type- Descending', value: 'broadcastType-desc' },
  { label: 'Genre - Ascending', value: 'channelGenre-asc' },
  { label: 'Genre - Descending', value: 'channelGenre-desc' },
];

export const EpgCorrectionJobsSortOptions: LabelValue[] = [
  //{label: 'Epg Program Id - Ascending', value: 'epgProgramId-asc'},
  //{label: 'Epg Program Id - Descending', value: 'epgProgramId-desc'},
  { label: 'Program - Ascending', value: 'program-asc' },
  { label: 'Program - Descending', value: 'program-desc' },
  { label: 'Channel Name - Ascending', value: 'channel-asc' },
  { label: 'Channel Name - Descending', value: 'channel-desc' },
  { label: 'Epg Correction Start Time - Ascending', value: 'startedOn-asc' },
  { label: 'Epg Correction Start Time - Descending', value: 'startedOn-desc' },
  { label: 'Epg Correction End Time - Ascending', value: 'endedOn-asc' },
  { label: 'Epg Correction End Time - Descending', value: 'endedOn-desc' },
  { label: 'Program Start Time - Ascending', value: 'startTime-asc' },
  { label: 'Program Start Time - Descending', value: 'startTime-desc' },
  { label: 'Program End Time - Ascending', value: 'endTime-asc' },
  { label: 'Program End Time - Descending', value: 'endTime-desc' }
];

export const TrailerSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Content Status - Ascending', value: 'contentStatus-asc' },
  { label: 'Content Status - Descending', value: 'contentStatus-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseMinStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseMinStartTime-desc' },
  { label: 'License End Time - Ascending', value: 'licenseMaxEndTime-asc' },
  { label: 'License End Time - Descending', value: 'licenseMaxEndTime-desc' },
  { label: 'Broadcast Time - Ascending', value: 'trailerBroadCastTime-asc' },
  { label: 'Broadcast Time - Descending', value: 'trailerBroadCastTime-desc' },
  { label: 'Trailer Operation Priority - Ascending', value: 'trailerPriority-asc' },
  { label: 'Trailer Operation Priority - Descending', value: 'trailerPriority-desc' },
  { label: 'Trailer Operation Name - Ascending', value: 'trailerOperationProcessName-asc' },
  { label: 'Trailer Operation Name - Descending', value: 'trailerOperationProcessName-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Trailer Promo - Ascending', value: 'trailerPromo-asc' },
  { label: 'Trailer Promo - Descending', value: 'trailerPromo-desc' },
  { label: 'Trailer Assignee - Ascending', value: 'trailerAssignee-asc' },
  { label: 'Trailer Assignee - Descending', value: 'trailerAssignee-desc' },
  { label: 'Trailer Creation Date - Ascending', value: 'trailerCreationDate-asc' },
  { label: 'Trailer Creation Date - Descending', value: 'trailerCreationDate-desc' },
];

export const TrailerOperationTaskSortOptions: LabelValue[] = [
  { label: 'Content Name - Ascending', value: 'contentName-asc' },
  { label: 'Content Name - Descending', value: 'contentName-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Content Status - Ascending', value: 'contentStatus-asc' },
  { label: 'Content Status - Descending', value: 'contentStatus-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseStartTime-desc' },
  { label: 'License End Time - Ascending', value: 'licenseEndTime-asc' },
  { label: 'License End Time - Descending', value: 'licenseEndTime-desc' },
  { label: 'Trailer Priority - Ascending', value: 'trailerPriority-asc' },
  { label: 'Trailer Priority - Descending', value: 'trailerPriority-desc' },
  { label: 'Trailer Broadcast Time - Ascending', value: 'trailerBroadCastTime-asc' },
  { label: 'Trailer Broadcast Time - Descending', value: 'trailerBroadCastTime-desc' },
  { label: 'Trailer Promo - Ascending', value: 'trailerPromo-asc' },
  { label: 'Trailer promo - Descending', value: 'trailerPromo-desc' },
  { label: 'Service Type - Ascending', value: 'serviceType-asc' },
  { label: 'Service Type - Descending', value: 'serviceType-desc' },
];

export const VfoAssignedToMeTasksSortOptions: LabelValue[] = [
  { label: 'Duration - Ascending', value: 'duration-asc' },
  { label: 'Duration - Descending', value: 'duration-desc' },
  { label: 'Content Name - Ascending', value: 'contentName-asc' },
  { label: 'Content Name - Descending', value: 'contentName-desc' },
  { label: 'Content Type - Ascending', value: 'contentType-asc' },
  { label: 'Content Type - Descending', value: 'contentType-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Content Status - Ascending', value: 'contentStatus-asc' },
  { label: 'Content Status - Descending', value: 'contentStatus-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseStartTime-desc' },
  { label: 'License End Time - Ascending', value: 'licenseEndTime-asc' },
  { label: 'License End Time - Descending', value: 'licenseEndTime-desc' },
  { label: 'Provider - Ascending', value: 'provider-asc' },
  { label: 'Provider - Descending', value: 'provider-desc' },
  { label: 'Censorship Edit Time - Ascending', value: 'censorshipEditTime-asc' },
  { label: 'Censorship Edit Time - Descending', value: 'censorshipEditTime-desc' },
  { label: 'Censorship Status - Ascending', value: 'censorshipStatus-asc' },
  { label: 'Censorship Status - Descending', value: 'censorshipStatus-desc' },
  { label: 'Service Type - Ascending', value: 'serviceType-asc' },
  { label: 'Service Type - Descending', value: 'serviceType-desc' },
  { label: 'Task Name - Ascending', value: 'taskName-asc' },
  { label: 'Task Name - Descending', value: 'taskName-desc' },
  { label: 'User Id - Ascending', value: 'userId-asc' },
  { label: 'User Id - Descending', value: 'userId-desc' },
  { label: 'User Name - Ascending', value: 'userName-asc' },
  { label: 'User Name - Descending', value: 'userName-desc' },
  { label: 'Comment - Ascending', value: 'comment-asc' },
  { label: 'Comment - Descending', value: 'comment-desc' },
  { label: 'Status - Ascending', value: 'status-asc' },
  { label: 'Status - Descending', value: 'status-desc' },
  // {label: 'Plan Start Time - Ascending', value: 'planMinStartTime-asc'},
  // {label: 'Plan Start Time - Descending', value: 'planMinStartTime-desc'},
  // {label: 'Plan End Time - Ascending', value: 'planMaxEndTime-asc'},
  // {label: 'Plan End Time - Descending', value: 'planMaxEndTime-desc'},
];

export const VfoAssignedTasksSortOptions: LabelValue[] = [
  { label: 'Content Name - Ascending', value: 'contentName-asc' },
  { label: 'Content Name - Descending', value: 'contentName-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Content Type - Ascending', value: 'contentType-asc' },
  { label: 'Content Type - Descending', value: 'contentType-desc' },
  { label: 'Duration - Ascending', value: 'duration-asc' },
  { label: 'Duration - Descending', value: 'duration-desc' },
  { label: 'Comment - Ascending', value: 'comment-asc' },
  { label: 'Comment - Descending', value: 'comment-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseStartTime-desc' },
  { label: 'License End Time - Ascending', value: 'licenseEndTime-asc' },
  { label: 'License End Time - Descending', value: 'licenseEndTime-desc' },
  // {label: 'Task Name - Ascending', value: 'taskName-asc'},
  // {label: 'Task Name - Descending', value: 'taskName-desc'},
  // {label: 'User Name - Ascending', value: 'userName-asc'},
  // {label: 'User Name - Descending', value: 'userName-desc'},
];

export const CensorshipPreviewNeedContentsSortOptions: LabelValue[] = [
  { label: 'Content Name - Ascending', value: 'name-asc' },
  { label: 'Content Name - Descending', value: 'name-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseMinStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseMinStartTime-desc' },
  // {label: 'License End Time - Ascending', value: 'licenseMaxEndTime-asc'},
  // {label: 'License End Time - Descending', value: 'licenseMaxEndTime-desc'},
  { label: 'Plan Start Time - Ascending', value: 'planMinStartTime-asc' },
  { label: 'Plan Start Time - Descending', value: 'planMinStartTime-desc' },
  { label: 'Plan End Time - Ascending', value: 'planMaxEndTime-asc' },
  { label: 'Plan End Time - Descending', value: 'planMaxEndTime-desc' },
  { label: 'Video File Status - Ascending', value: 'vfoProcessName-asc' },
  { label: 'Video File Status - Descending', value: 'vfoProcessName-desc' },
  { label: 'Service Type - Ascending', value: 'serviceType-asc' },
  { label: 'Service Type - Descending', value: 'serviceType-desc' },
];

export const IngestFailedContentsSortOptions: LabelValue[] = [
  { label: 'Content Name - Ascending', value: 'name-asc' },
  { label: 'Content Name - Descending', value: 'name-desc' },
  { label: 'Plan Start Time - Ascending', value: 'planMinStartTime-asc' },
  { label: 'Plan Start Time - Descending', value: 'planMinStartTime-desc' },
  { label: 'Plan End Time - Ascending', value: 'planMaxEndTime-asc' },
  { label: 'Plan End Time - Descending', value: 'planMaxEndTime-desc' },
];

export const IngestFailedCatchupsSortOptions: LabelValue[] = [
  { label: 'Content Name - Ascending', value: 'name-asc' },
  { label: 'Content Name - Descending', value: 'name-desc' },
  { label: 'Plan Start Time - Ascending', value: 'planMinStartTime-asc' },
  { label: 'Plan Start Time - Descending', value: 'planMinStartTime-desc' },
  { label: 'Plan End Time - Ascending', value: 'planMaxEndTime-asc' },
  { label: 'Plan End Time - Descending', value: 'planMaxEndTime-desc' },
  { label: 'Channel Name - Ascending', value: 'channelName-asc' },
  { label: 'Channel Name - Descending', value: 'channelName-desc' },
  { label: 'Genre - Ascending', value: 'genre-asc' },
  { label: 'Genre - Descending', value: 'genre-desc' },
];
export const contentEncodingSortOptions: LabelValue[] = [
  { label: 'Video Format - Ascending', value: 'videoFormat-asc' },
  { label: 'Video Format - Descending', value: 'videoFormat-desc' },
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Encoding Profile - Ascending', value: 'encProfile-asc' },
  { label: 'Encoding Profile - Descending', value: 'encProfile-desc' },
  { label: 'Profil Type - Ascending', value: 'profileType-asc' },
  { label: 'Profil Type - Descending', value: 'profileType-desc' },
  { label: 'Key Frame Period - Ascending', value: 'keyFramePeriod-asc' },
  { label: 'Key Frame Period - Descending', value: 'keyFramePeriod-desc' },
  { label: 'Resolution - Ascending', value: 'resolution-asc' },
  { label: 'Resolution - Descending', value: 'resolution-desc' },
  { label: 'Frame Rate - Ascending', value: 'frameRate-asc' },
  { label: 'Frame Rate - Descending', value: 'frameRate-desc' },
  { label: 'Video Bit Rate - Ascending', value: 'videoBitRate-asc' },
  { label: 'Video Bit Rate - Descending', value: 'videoBitRate-desc' },
  { label: 'Audio Codec - Ascending', value: 'audioCodec-asc' },
  { label: 'Audio Codec - Descending', value: 'audioCodec-desc' },
  { label: 'Width - Ascending', value: 'width-asc' },
  { label: 'Width - Descending', value: 'width-desc' },
  { label: 'Height - Ascending', value: 'height-asc' },
  { label: 'Height - Descending', value: 'height-desc' },
];
export const vodContentGroupSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
];

export const IngestManagementSortOptions: LabelValue[] = [
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Create Date - Ascending', value: 'creationDate-asc' },
  { label: 'Create Date - Descending', value: 'creationDate-desc' },
  { label: 'Send Date - Ascending', value: 'startTime-asc' },
  { label: 'Send Date - Descending', value: 'startTime-desc' },
  { label: 'End Date - Ascending', value: 'endTime-asc' },
  { label: 'End Date - Descending', value: 'endTime-desc' },
  { label: 'Operation - Ascending', value: 'operation-asc' },
  { label: 'Operation - Descending', value: 'operation-desc' },
  { label: 'Action - Ascending', value: 'action-asc' },
  { label: 'Action - Descending', value: 'action-desc' },
  { label: 'Status - Ascending', value: 'status-asc' },
  { label: 'Status - Descending', value: 'status-desc' },
];

export const UserSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Last Name - Ascending', value: 'surname-asc' },
  { label: 'Last Name - Descending', value: 'surname-desc' },
  { label: 'Role - Ascending', value: 'roleName-asc' },
  { label: 'Role - Descending', value: 'roleName-desc' },
  { label: 'Title - Ascending', value: 'title-asc' },
  { label: 'Title - Descending', value: 'title-desc' },
];
export const RoleSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Number of Users - Ascending', value: 'userCount-asc' },
  { label: 'Number of Users - Descending', value: 'userCount-desc' },
  { label: 'Number of Privileges - Ascending', value: 'numberOfPrivileges-asc' },
  { label: 'Number of Privileges - Descending', value: 'numberOfPrivileges-desc' },
];
export const ChannelsSortOptions: LabelValue[] = [
  { label: 'Channel Name - Ascending', value: 'name-asc' },
  { label: 'Channel Name - Descending', value: 'name-desc' },
];

export const CdnDownloadRequestsSortOptions: LabelValue[] = [
  { label: 'Channel Name - Ascending', value: 'channelName-asc' },
  { label: 'Channel Name - Descending', value: 'channelName-desc' },
  { label: 'Start Time - Ascending', value: 'startTime-asc' },
  { label: 'Start Time - Descending', value: 'startTime-desc' },
  { label: 'End Time - Ascending', value: 'endTime-asc' },
  { label: 'End Time - Descending', value: 'endTime-desc' },
];

export const TransferAndProfilingFailedSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Provider - Ascending', value: 'provider-asc' },
  { label: 'Provider - Descending', value: 'provider-desc' },
  { label: 'License Start Time - Ascending', value: 'licenseMinStartTime-asc' },
  { label: 'License Start Time - Descending', value: 'licenseMinStartTime-desc' },
  { label: 'License End Time - Ascending', value: 'licenseMaxEndTime-asc' },
  { label: 'License End Time - Descending', value: 'licenseMaxEndTime-desc' },
  { label: 'Video Operation Process  Name - Ascending', value: 'vfoProcessName-asc' },
  { label: 'Video Operation Process  Name - Descending', value: 'vfoProcessName-desc' },
  { label: 'Status - Ascending', value: 'contentStatus-asc' },
  { label: 'Status - Descending', value: 'contentStatus-desc' },
];

export const EpgActivityStreamSortOptions: LabelValue[] = [
  // {label: 'Epg Program Id - Ascending', value: 'epgProgramId-asc'},
  // {label: 'Epg Program Id - Descending', value: 'epgProgramId-desc'},
  { label: 'Channel Name - Ascending', value: 'channelName-asc' },
  { label: 'Channel Name - Descending', value: 'channelName-desc' },
  { label: 'Epg Name - Ascending', value: 'epgName-asc' },
  { label: 'Epg Name - Descending', value: 'epgName-desc' },
  { label: 'Release Date - Ascending', value: 'releaseDate-asc' },
  { label: 'Release Date - Descending', value: 'releaseDate-desc' },
  { label: 'Start Time - Ascending', value: 'beginTime-asc' },
  { label: 'Start Time - Descending', value: 'beginTime-desc' },
  { label: 'End Time - Ascending', value: 'endTime-asc' },
  { label: 'End Time - Descending', value: 'endTime-desc' },
  { label: 'Change Type - Ascending', value: 'changeType-asc' },
  { label: 'Change Type - Descending', value: 'changeType-desc' },
  { label: 'Change Time - Ascending', value: 'changeTime-asc' },
  { label: 'Change Time - Descending', value: 'changeTime-desc' },
  { label: 'Username- Ascending', value: 'username-asc' },
  { label: 'Username - Descending', value: 'username-desc' },
];
export const EncodingJobsSortOptions: LabelValue[] = [
  { label: 'Encoding Profil Name - Ascending', value: 'encProfileName-asc' },
  { label: 'Encoding Profil Name - Descending', value: 'encProfileName-desc' },
  { label: 'Encoding Station Name - Ascending', value: 'encStationName-asc' },
  { label: 'Encoding Station Name - Descending', value: 'encStationName-desc' },
  { label: 'Bit Rate - Ascending', value: 'videoBitRate-asc' },
  { label: 'Bit Rate - Descending', value: 'videoBitRate-desc' },
  { label: 'Status - Ascending', value: 'status-asc' },
  { label: 'Status - Descending', value: 'status-desc' },
  { label: 'Update Time - Ascending', value: 'changeDate-asc' },
  { label: 'Update Time - Descending', value: 'changeDate-desc' },
];
export const CampaignsSortOptions: LabelValue[] = [
  { label: 'Start Time - Ascending', value: 'startTime-asc' },
  { label: 'Start Time - Descending', value: 'startTime-desc' },
  { label: 'End Time - Ascending', value: 'endTime-asc' },
  { label: 'End Time - Descending', value: 'endTime-desc' },
  { label: 'Campaign Name - Ascending', value: 'name-asc' },
  { label: 'Campaign Name - Descending', value: 'name-desc' },
];

export const SectionInfoContentSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Status - Ascending', value: 'contentStatus-asc' },
  { label: 'Status - Descending', value: 'contentStatus-desc' },
  { label: 'Count - Ascending', value: 'count-asc' },
  { label: 'Count - Descending', value: 'count-desc' },
];

export const ComingSoonContentSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Publish Time - Ascending', value: 'publishTime-asc' },
  { label: 'Publish Time - Descending', value: 'publishTime-desc' },
  { label: 'Unpublish Time - Ascending', value: 'unpublishTime-asc' },
  { label: 'Unpublish Time - Descending', value: 'unpublishTime-desc' },
  { label: 'Guid - Ascending', value: 'guid-asc' },
  { label: 'Guid - Descending', value: 'guid-desc' },
  { label: 'Plan Start Time - Ascending', value: 'planStartTime-asc' },
  { label: 'Plan Start Time - Descending', value: 'planStartTime-desc' },
  { label: 'Plan End Time - Ascending', value: 'planEndTime-asc' },
  { label: 'Plan End Time - Descending', value: 'planEndTime-desc' },
  { label: 'Creation Date - Ascending', value: 'creationDate-asc' },
  { label: 'Creation Date - Descending', value: 'creationDate-desc' },
];

export const ComingSoonTrailProcess: LabelValue[] = [
  { label: 'Text', value: 'Text' },
  { label: 'VoiceOver', value: 'VoiceOver' },
  { label: 'Online', value: 'Online' },
  { label: 'FinalCheck', value: 'FinalCheck' },
  { label: 'Planning', value: 'Planning' },
  { label: 'Transfer', value: 'Transfer' },
  { label: 'Transcoding2nd', value: 'Transcoding2nd' },
  { label: 'Completed', value: 'Completed' },
  { label: 'Poster', value: 'Poster' },
];

export const FilterPresetDataKeys: LabelValue[] = [
  { label: 'Year', value: 'year' },
  { label: 'Title', value: 'title' },
  { label: 'Providers', value: 'provider' },
  { label: 'Duration', value: 'duration' },
  { label: 'IMDB Rating', value: 'imdbRating' },
  { label: 'Country', value: 'country' },
  { label: 'Casts', value: 'castName' },
  { label: 'Metadata Summary', value: 'metadataSummary' },
  { label: 'Genres', value: 'genreName' },
  { label: 'Publish Time', value: 'publishTime' },
  { label: 'Service Type', value: 'serviceType' },
  { label: 'Content Type', value: 'contentType' },
  { label: '', value: 'publishTime' },
];

export const FilterPresetDataOperations: LabelValue[] = [
  { label: 'In', value: 'in' },
  { label: 'Less Than Equals', value: 'lessThanEquals' },
  { label: 'Greater Than Equals', value: 'greaterThanEquals' },
  { label: 'Between', value: 'between' },
  { label: 'Equal', value: 'equals' },
  { label: 'Greater Than', value: 'greaterThan' },
  { label: 'Less Than', value: 'lessThan' },
  { label: 'Contains', value: 'contains' },
];

export const ConfigSortOptions: LabelValue[] = [
  { label: 'Key - Ascending', value: 'key-asc' },
  { label: 'Key - Descending', value: 'key-desc' },
  { label: 'Value - Ascending', value: 'value-asc' },
  { label: 'Value - Descending', value: 'value-desc' },
  { label: 'Description - Ascending', value: 'description-asc' },
  { label: 'Description - Descending', value: 'description-desc' },
];

export const posterDefinitionSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Aspect Ratio - Ascending', value: 'aspectRatio-asc' },
  { label: 'Aspect Ratio - Descending', value: 'aspectRatio-desc' },
  { label: 'Width - Ascending', value: 'width-asc' },
  { label: 'Width - Descending', value: 'width-desc' },
  { label: 'Height - Ascending', value: 'height-asc' },
  { label: 'Height - Descending', value: 'height-desc' },
  { label: 'File Size - Ascending', value: 'fileSize-asc' },
  { label: 'File Size - Descending', value: 'fileSize-desc' },
  { label: 'Mandatory Poster - Ascending', value: 'mandatoryPoster-asc' },
  { label: 'Mandatory Poster - Descending', value: 'mandatoryPoster-desc' },
  { label: 'Category Poster - Ascending', value: 'catalogPoster-asc' },
  { label: 'Category Poster - Descending', value: 'catalogPoster-desc' },
  { label: 'Quality Ratio - Ascending', value: 'compressRatio-asc' },
  { label: 'Quality Ratio - Descending', value: 'compressRatio-desc' },
];

export const SectionInfoOptions: LabelValue[] = [
  {
    label: 'Intro',
    value: 1,
  },
  {
    label: 'Advertisement',
    value: 2,
  },
  {
    label: 'Next Episode',
    value: 3,
  },
  {
    label: 'Trailer',
    value: 4,
  },
];

export const TrimIntroOptions: LabelValue[] = [
  {
    label: 'Intro',
    value: 1,
  },
  {
    label: 'Summary',
    value: 2,
  },
  {
    label: 'Next Episode',
    value: 3,
  },
  {
    label: 'Trailer',
    value: 4,
  },
];

export const ContentSectionInfoOptions: LabelValue[] = [
  {
    label: 'Intro',
    value: 1,
  },
  {
    label: 'Summary',
    value: 2,
  },
  {
    label: 'Next Episode',
    value: 3,
  },
  {
    label: 'Trailer',
    value: 4,
  },
];

export const CustomTextOptions: LabelValue[] = [
  {
    label: 'Intro',
    value: 1,
  },
  {
    label: 'Summary',
    value: 2,
  },
  {
    label: 'Next Episode',
    value: 3,
  },
];

export const TrailerOption: LabelValue = {
  label: 'Trailer',
  value: 4,
};

export const ValidationEventActivityLogsSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Vod Type - Ascending', value: 'vodType-asc' },
  { label: 'Vod Type - Descending', value: 'vodType-desc' },
  { label: 'Action Time - Ascending', value: 'actionTime-asc' },
  { label: 'Action Time - Descending', value: 'actionTime-desc' },
  { label: 'Action - Ascending', value: 'action-asc' },
  { label: 'Action - Descending', value: 'action-desc' },
  { label: 'User Name - Ascending', value: 'userName-asc' },
  { label: 'User Name - Descending', value: 'userName-desc' },
  { label: 'Issue Type - Ascending', value: 'issueType-asc' },
  { label: 'Issue Type - Descending', value: 'issueType-desc' },
];


export const CustomerSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Surname - Ascending', value: 'surname-asc' },
  { label: 'Surname - Descending', value: 'surname-desc' },
  { label: 'Email - Ascending', value: 'email-asc' },
  { label: 'Email - Descending', value: 'email-desc' },
  { label: 'Service ID - Ascending', value: 'serviceId-asc' },
  { label: 'Service ID - Descending', value: 'serviceId-desc' },
  { label: 'Status - Ascending', value: 'status-asc' },
  { label: 'Status - Descending', value: 'status-desc' },
  { label: 'Creation Date - Ascending', value: 'creationDate-asc' },
  { label: 'Creation Date - Descending', value: 'creationDate-desc' },
  { label: 'Last Update - Ascending', value: 'lastUpdateDate-asc' },
  { label: 'Last Update - Descending', value: 'lastUpdateDate-desc' },
  { label: 'Username - Ascending', value: 'username-asc' },
  { label: 'Username - Descending', value: 'username-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Account ID - Ascending', value: 'accountId-asc' },
  { label: 'Account ID - Descending', value: 'accountId-desc' },
];

export const ProductSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Type - Ascending', value: 'type-asc' },
  { label: 'Type - Descending', value: 'type-desc' },
  { label: 'Price - Ascending', value: 'price-asc' },
  { label: 'Price - Descending', value: 'price-desc' },
  { label: 'ID - Ascending', value: 'id-asc' },
  { label: 'ID - Descending', value: 'id-desc' },
  { label: 'Status - Ascending', value: 'status-asc' },
  { label: 'Status - Descending', value: 'status-desc' },
  { label: 'Creation Date - Ascending', value: 'creationDate-asc' },
  { label: 'Creation Date - Descending', value: 'creationDate-desc' },
  { label: 'Kodsis ID - Ascending', value: 'kodsisPackageId-asc' },
  { label: 'Kodsis ID - Descending', value: 'kodsisPackageId-desc' },
];

export const LanguageSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Code - Ascending', value: 'code-asc' },
  { label: 'Code - Descending', value: 'code-desc' },
  { label: 'Display Name - Ascending', value: 'displayName-asc' },
  { label: 'Display Name - Descending', value: 'displayName-desc' },
  { label: 'Created At - Ascending', value: 'createdAt-asc' },
  { label: 'Created At - Descending', value: 'createdAt-desc' },
  { label: 'Updated At - Ascending', value: 'updatedAt-asc' },
  { label: 'Updated At - Descending', value: 'updatedAt-desc' },
];

export const TranslationSortOptions: LabelValue[] = [
  { label: 'ID - Ascending', value: 'id-asc' },
  { label: 'ID - Descending', value: 'id-desc' },

  { label: 'Language Name - Ascending', value: 'languageName-asc' },
  { label: 'Language Name - Descending', value: 'languageName-desc' },

  { label: 'Language Code - Ascending', value: 'languageCode-asc' },
  { label: 'Language Code - Descending', value: 'languageCode-desc' },

  { label: 'Text - Ascending', value: 'key-asc' },
  { label: 'Text - Descending', value: 'key-desc' },

  { label: 'Translation - Ascending', value: 'translation-asc' },
  { label: 'Translation - Descending', value: 'translation-desc' },
];

export const SettingSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },

  { label: 'Description - Ascending', value: 'description-asc' },
  { label: 'Description - Descending', value: 'description-desc' },

  { label: 'Device Type - Ascending', value: 'deviceType-asc' },
  { label: 'Device Type - Descending', value: 'deviceType-desc' },

  { label: 'Data Type - Ascending', value: 'dataType-asc' },
  { label: 'Data Type - Descending', value: 'dataType-desc' },

  { label: 'Value - Ascending', value: 'value-asc' },
  { label: 'Value - Descending', value: 'value-desc' },
];

export const ResultCodeSortOptions: LabelValue[] = [
  { label: 'Code - Ascending', value: 'code-asc' },
  { label: 'Code - Descending', value: 'code-desc' },
  { label: 'Label - Ascending', value: 'label-asc' },
  { label: 'Label - Descending', value: 'label-desc' },
  { label: 'Message - Ascending', value: 'message-asc' },
  { label: 'Message - Descending', value: 'message-desc' },
];

export const DeviceSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },
  { label: 'Code - Ascending', value: 'code-asc' },
  { label: 'Code - Descending', value: 'code-desc' },
  { label: 'Identifiers - Ascending', value: 'identifiers-asc' },
  { label: 'Identifiers - Descending', value: 'identifiers-desc' },
  { label: 'Api Key - Ascending', value: 'apiKey-asc' },
  { label: 'Api Key - Descending', value: 'apiKey-desc' },
  { label: 'Created At - Ascending', value: 'createdAt-asc' },
  { label: 'Created At - Descending', value: 'createdAt-desc' },
  { label: 'Updated At - Ascending', value: 'updatedAt-asc' },
  { label: 'Updated At - Descending', value: 'updatedAt-desc' },
];

export const ClientVersionSortOptions: LabelValue[] = [
  { label: 'Name - Ascending', value: 'name-asc' },
  { label: 'Name - Descending', value: 'name-desc' },

  { label: 'Description - Ascending', value: 'description-asc' },
  { label: 'Description - Descending', value: 'description-desc' },

  { label: 'Device Type - Ascending', value: 'deviceType-asc' },
  { label: 'Device Type - Descending', value: 'deviceType-desc' },

  { label: 'Version - Ascending', value: 'version-asc' },
  { label: 'Version - Descending', value: 'version-desc' },

  { label: 'Build Number - Ascending', value: 'buildNumber-asc' },
  { label: 'Build Number - Descending', value: 'buildNumber-desc' },

  { label: 'Created At - Ascending', value: 'createdAt-asc' },
  { label: 'Created At - Descending', value: 'createdAt-desc' },

  { label: 'Updated At - Ascending', value: 'updatedAt-asc' },
  { label: 'Updated At - Descending', value: 'updatedAt-desc' },
];

export const SystemModuleSettingSortOptions: LabelValue[] = [
  { label: 'Device Type - Ascending', value: 'deviceType-asc' },
  { label: 'Device Type - Descending', value: 'deviceType-desc' },
];

export const ProfileAvatarSortOptions: LabelValue[] = [
  { label: 'Name - Asc', value: 'name-asc' },
  { label: 'Name - Desc', value: 'name-desc' },
  { label: 'Created - Asc', value: 'createdAt-asc' },
  { label: 'Created - Desc', value: 'createdAt-desc' },
  { label: 'Updated - Asc', value: 'updatedAt-asc' },
  { label: 'Updated - Desc', value: 'updatedAt-desc' },
];

export const AvatarGroupSortOptions: LabelValue[] = [
  { label: 'Name - Asc', value: 'name-asc' },
  { label: 'Name - Desc', value: 'name-desc' },

  { label: 'Alignment - Asc', value: 'displayOrder-asc' },
  { label: 'Alignment - Desc', value: 'displayOrder-desc' },

  { label: 'Created - Asc', value: 'createdAt-asc' },
  { label: 'Created - Desc', value: 'createdAt-desc' },

  { label: 'Updated - Asc', value: 'updatedAt-asc' },
  { label: 'Updated - Desc', value: 'updatedAt-desc' }
]

export const AvatarGroupItemSortOptions: LabelValue[] = [
  { label: 'Avatar Name - Asc', value: 'profileAvatarName-asc' },
  { label: 'Avatar Name - Desc', value: 'profileAvatarName-desc' },
  { label: 'Avatar Id - Asc', value: 'profileAvatarId-asc' },
  { label: 'Avatar Id - Desc', value: 'profileAvatarId-desc' },
  { label: 'Item Id - Asc', value: 'id-asc' },
  { label: 'Item Id - Desc', value: 'id-desc' },
];

export const labelSortOptions: LabelValue[] = [
  { label: 'Label Name - Asc', value: 'name-asc' },
  { label: 'Label Name - Desc', value: 'name-desc' },

  { label: 'Platform - Asc', value: 'platform-asc' },
  { label: 'Platform - Desc', value: 'platform-desc' },

  { label: 'Menu Item - Asc', value: 'menuItemName-asc' },
  { label: 'Menu Item - Desc', value: 'menuItemName-desc' },

  { label: 'Category - Asc', value: 'categoryName-asc' },
  { label: 'Category - Desc', value: 'categoryName-desc' },

  { label: 'Type - Asc', value: 'type-asc' },
  { label: 'Type - Desc', value: 'type-desc' },

  { label: 'Vod Type - Asc', value: 'vodType-asc' },
  { label: 'Vod Type - Desc', value: 'vodType-desc' },

  { label: 'Dynamic Type - Asc', value: 'labelType-asc' },
  { label: 'Dynamic Type - Desc', value: 'labelType-desc' },

  { label: 'Visibility - Asc', value: 'visibility-asc' },
  { label: 'Visibility - Desc', value: 'visibility-desc' },
];

export const categorySortOptions: any[] = [
  { label: 'Category Name - Asc', value: 'name-asc' },
  { label: 'Category Name - Desc', value: 'name-desc' },
];

export const menuItemSortOptions: any[] = [
  { label: 'Platform - Ascending', value: 'platform-asc' },
  { label: 'Platform - Descending', value: 'platform-desc' },

  { label: 'Menu Item Name - Ascending', value: 'name-asc' },
  { label: 'Menu Item Name - Descending', value: 'name-desc' },

  { label: 'Visibility - Ascending', value: 'visibility-asc' },
  { label: 'Visibility - Descending', value: 'visibility-desc' },

  { label: 'Is Main - Ascending', value: 'isMain-asc' },
  { label: 'Is Main - Descending', value: 'isMain-desc' },

  { label: 'Is Kid - Ascending', value: 'child-asc' },
  { label: 'Is Kid - Descending', value: 'child-desc' },

  { label: 'Id - Ascending', value: 'id-asc' },
  { label: 'Id - Descending', value: 'id-desc' },
];
